var _rect, _path, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisabledCameraIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 572,
    height: 503,
    viewBox: "0 0 572 503",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 109.999,
    width: 352,
    height: 288,
    rx: 34,
    stroke: "#2C2C2C",
    strokeWidth: 32
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M534.124 351.46L440.624 307.549C435.36 305.077 432 299.786 432 293.972V210.812C432 204.851 435.529 199.456 440.991 197.068L534.491 156.185C544.401 151.852 555.5 159.113 555.5 169.929V337.883C555.5 348.873 544.071 356.132 534.124 351.46Z",
    stroke: "#2C2C2C",
    strokeWidth: 32
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 491.661,
    x2: 491.661,
    y2: 7.99999,
    stroke: "#FF3B30",
    strokeWidth: 16,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledCameraIcon);
export default __webpack_public_path__ + "static/media/disabled-camera-icon.ddd2e43b88abf9f9cf90dec29e70d0be.svg";
export { ForwardRef as ReactComponent };